module.exports = __webpack_public_path__ + "img/myBj.a72b3742.png";